module.exports = __webpack_public_path__ + "img/域贝可视化带框.3189a80e.png";